import {
    ComponentPropsWithoutRef,
    ElementType,
    PropsWithChildren,
    ReactElement,
} from 'react'

type BoxOwnProps<C extends ElementType = 'div'> = {
    flex?: boolean
    grow?: boolean
    alignItems?: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
    justifyItems?: 'start' | 'center' | 'end' | 'between' | 'around'
    justifyContent?: 'start' | 'center' | 'end' | 'between' | 'around'
    component?: C
}

type BoxProps<C extends ElementType = 'div'> = BoxOwnProps<C> &
    Omit<ComponentPropsWithoutRef<C>, keyof BoxOwnProps<C>>

function Box<C extends ElementType = 'div'>({
    style,
    flex,
    grow,
    alignItems,
    justifyItems,
    justifyContent,
    children,
    component,
    ...rest
}: PropsWithChildren<BoxProps<C>>): ReactElement {
    const Component = component ?? 'div'
    let appliedStyle = style

    if (flex) {
        appliedStyle = {
            ...appliedStyle,
            display: 'flex',
        }
        if (grow) {
            appliedStyle = {
                ...appliedStyle,
                flexGrow: 1,
            }
        }
        if (alignItems) {
            appliedStyle = {
                ...appliedStyle,
                alignItems,
            }
        }
        if (justifyItems) {
            appliedStyle = {
                ...appliedStyle,
                justifyItems,
            }
        }
        if (justifyContent) {
            appliedStyle = {
                ...appliedStyle,
                justifyContent,
            }
        }
    }

    return (
        <Component style={appliedStyle} {...rest}>
            {children}
        </Component>
    )
}

export default Box
